import FavouriteIcon from '../../../../../base-image/components/Matrix/FavouriteIcon';

import Column from './Column';

const Product = ({id, title, columnFilter, columns, isFavourite}) => (
    <tr id={`product-${id}`}>
        <td className="product-title">
            <span className="mark-favorite">
                <FavouriteIcon id={id} isFavourite={isFavourite} />
            </span>
            <span className="product-title-txt">{title}</span>
        </td>
        {columnFilter(columns).map(column => <Column {...column} />)}
    </tr>
);

export default Product;
